import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { Button, Grid, GridColumn, Notice, Separator } from '@teliaee/design-system';
import LoginButton from '../components/LoginButton';
import useStores from '../stores/UseStores';
import { FetchStatus } from '../util/ApiUtil';
import { isWebAuthSupported } from '../util/BrowserUtil';

const PasskeyLogin = observer((): React.JSX.Element => {
  const {
    uiStore: { setSelectedTab },
    smartIdLoginStore,
    mobileIdLoginStore,
    passkeyStore,
    translateStore: { translate },
  } = useStores();

  const [showPasskeyLoginView, setShowPasskeyLoginView] = useState(passkeyStore.getPasskeyExists());

  if (!isWebAuthSupported()) {
    return <Notice type="attention">{translate('passkey.login.webAuthNotSupported')}</Notice>;
  }

  if (showPasskeyLoginView) {
    return (
      <Grid horizontalGutter="none" verticalGutter="smedium">
        <GridColumn>
          <Separator spacing="xxsmall" weight="thin" />
        </GridColumn>
        <GridColumn>
          <LoginButton
            isLoading={passkeyStore.status === FetchStatus.FETCHING}
            onClick={() => {
              passkeyStore.authenticate();
            }}
          />
        </GridColumn>
        <GridColumn>
          <Button link text={translate('passkey.add.new')} onClick={() => setShowPasskeyLoginView(false)} iconLeft="#plus" />
        </GridColumn>
      </Grid>
    );
  }

  return (
    <Grid horizontalGutter="none" verticalGutter="smedium">
      <GridColumn>
        <Separator spacing="xxsmall" weight="thin" />
      </GridColumn>
      <GridColumn>
        <Button
          block
          text={translate('passkey.bind.with.mobileId')}
          iconRight="#arrow-right"
          onClick={() => {
            setSelectedTab('mobileId');
            mobileIdLoginStore.shouldSavePasskeyAfterLogin = true;
          }}
        />
      </GridColumn>
      <GridColumn>
        <Button
          block
          text={translate('passkey.bind.with.smartId')}
          iconRight="#arrow-right"
          onClick={() => {
            setSelectedTab('smartId');
            smartIdLoginStore.shouldSavePasskeyAfterLogin = true;
          }}
        />
      </GridColumn>
      <GridColumn>
        <Notice size="small" type="info">
          {translate('passkey.login.notice')}
        </Notice>
      </GridColumn>
      <GridColumn>
        <Button
          link
          text={translate('passkey.login.with.passkey')}
          onClick={() => {
            setShowPasskeyLoginView(true);
            passkeyStore.authenticate();
          }}
          iconRight="#arrow-right"
        />
      </GridColumn>
    </Grid>
  );
});

export default PasskeyLogin;
